module.exports = __webpack_public_path__ + "static/media/G.6a33cd42.jpg";